module.exports = __webpack_public_path__ + "static/media/Joao_Bernardino.4270355d.jpg";